"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRebalanceTxb = getRebalanceTxb;
exports.checkRatio = checkRatio;
exports.priceToTickIndexBoth = priceToTickIndexBoth;
exports.getManualRebalanceTxb = getManualRebalanceTxb;
exports.getManualRebalanceUsingTicksTxb = getManualRebalanceUsingTicksTxb;
exports.getManualRebalanceUsingTicksLoopsTxb = getManualRebalanceUsingTicksLoopsTxb;
exports.migrateToNewPool = migrateToNewPool;
const tslib_1 = require("tslib");
const transactions_1 = require("@mysten/sui/transactions");
const alphafi_sdk_1 = require("@alphafi/alphafi-sdk");
const index_js_1 = require("../protocol/index.js");
const bn_js_1 = tslib_1.__importDefault(require("bn.js"));
const cetus_sui_clmm_sdk_1 = require("@cetusprotocol/cetus-sui-clmm-sdk");
const decimal_js_1 = require("decimal.js");
const index_js_2 = require("../index.js");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
const alphalend_sdk_1 = require("@alphafi/alphalend-sdk");
const stablePoolNames = [
    "USDC-USDT",
    "USDC-WUSDC",
    "USDT-WUSDC",
    "BLUEFIN-USDT-USDC",
    "BLUEFIN-AUSD-USDC",
    "BLUEFIN-AUTOBALANCE-SUIUSDT-USDC",
    "BLUEFIN-AUTOBALANCE-USDT-USDC",
    "BLUEFIN-SUIUSDT-USDC",
    "USDC-SUIUSDT",
    "BLUEFIN-AUTOBALANCE-SUIUSDT-USDC-ZERO-ZERO",
];
async function getRebalanceTxb(poolName, rebalanceCap, percentageLimit, swap_using_bluefin, rebalance_using_base_pool) {
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    let clmmPool;
    let investor;
    let tickSpacing;
    if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        clmmPool = (await (0, alphafi_sdk_1.getCetusPool)(poolName, true));
        investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, true));
        tickSpacing = clmmPool.content.fields.tick_spacing;
    }
    else {
        clmmPool = (await (0, alphafi_sdk_1.getParentPool)(poolName, true));
        investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, true));
        tickSpacing = clmmPool.content.fields.ticks_manager.fields.tick_spacing;
    }
    const pool = await (0, alphafi_sdk_1.getPool)(poolName, true);
    if (!clmmPool || !investor || !pool) {
        throw new Error("couldnt fetch object");
    }
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    const liquidity = pool.content.fields.tokensInvested;
    const current_sqrt_price = new bn_js_1.default(clmmPool.content.fields.current_sqrt_price);
    const upperBound = 443636;
    let curLowerTick = Number(investor.content.fields.lower_tick);
    let curUpperTick = Number(investor.content.fields.upper_tick);
    if (curLowerTick > upperBound) {
        curLowerTick = -~(curLowerTick - 1);
    }
    if (curUpperTick > upperBound) {
        curUpperTick = -~(curUpperTick - 1);
    }
    const upper_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(curUpperTick);
    const lower_sqrt_price = cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(curLowerTick);
    const coinAmounts = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(new bn_js_1.default(Math.floor(parseFloat(liquidity)).toString()), current_sqrt_price, lower_sqrt_price, upper_sqrt_price, false);
    const amount0 = coinAmounts.coinA.toNumber();
    const amount1 = coinAmounts.coinB.toNumber();
    let lowerTick = 0;
    let upperTick = 0;
    let txb;
    if (stablePoolNames.includes(poolName)) {
        let currentTickIndex = clmmPool.content.fields.current_tick_index.fields.bits;
        if (currentTickIndex > upperBound) {
            currentTickIndex = -~(currentTickIndex - 1);
        }
        if (poolName === "BLUEFIN-SUIUSDT-USDC" ||
            poolName.includes("-AUTOBALANCE-")) {
            let intermediateLowerTick = 0;
            let intermediateUpperTick = 0;
            lowerTick = curLowerTick;
            upperTick = curUpperTick;
            if (currentTickIndex >= curUpperTick) {
                lowerTick = currentTickIndex;
                upperTick = currentTickIndex + 1;
                intermediateUpperTick = upperTick;
                intermediateLowerTick = upperTick - 4;
                txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
            }
            else if (currentTickIndex < curLowerTick) {
                lowerTick = currentTickIndex;
                upperTick = currentTickIndex + 1;
                intermediateLowerTick = lowerTick;
                intermediateUpperTick = lowerTick + 4;
                txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
            }
            else {
                if (current_sqrt_price
                    .sub(lower_sqrt_price)
                    .mul(new bn_js_1.default(100))
                    .div(upper_sqrt_price.sub(lower_sqrt_price))
                    .lte(new bn_js_1.default(10))) {
                    lowerTick = currentTickIndex - 1;
                    upperTick = currentTickIndex;
                    intermediateLowerTick = lowerTick;
                    intermediateUpperTick = lowerTick + 4;
                    txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
                }
                else if (upper_sqrt_price
                    .sub(current_sqrt_price)
                    .mul(new bn_js_1.default(100))
                    .div(upper_sqrt_price.sub(lower_sqrt_price))
                    .lte(new bn_js_1.default(10))) {
                    lowerTick = currentTickIndex + 1;
                    upperTick = currentTickIndex + 2;
                    intermediateUpperTick = upperTick;
                    intermediateLowerTick = upperTick - 4;
                    txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
                }
                else {
                    lowerTick = currentTickIndex;
                    upperTick = currentTickIndex + 1;
                    intermediateLowerTick = lowerTick;
                    intermediateUpperTick = lowerTick + 4;
                    txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
                    console.log("hi baby", lowerTick, upperTick, currentTickIndex);
                }
            }
        }
        else if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "BLUEFIN") {
            lowerTick = currentTickIndex - 1;
            upperTick = currentTickIndex + 1;
        }
        else {
            if (currentTickIndex >= curUpperTick) {
                if (currentTickIndex & 1) {
                    currentTickIndex = currentTickIndex - 1;
                }
                lowerTick = currentTickIndex;
                upperTick = currentTickIndex + 2;
            }
            else {
                if (currentTickIndex & 1) {
                    currentTickIndex = currentTickIndex + 1;
                }
                lowerTick = currentTickIndex - 2;
                upperTick = currentTickIndex;
            }
            let intermediateLowerTick = lowerTick;
            let intermediateUpperTick = upperTick;
            if (currentTickIndex >= curUpperTick) {
                intermediateLowerTick -= 2;
            }
            else {
                intermediateUpperTick += 2;
            }
            txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, intermediateLowerTick.toString(), intermediateUpperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
        }
    }
    else {
        const spaceBetweenCurTicks = curUpperTick - curLowerTick;
        let currentTickIndex = clmmPool?.content.fields.current_tick_index.fields.bits;
        if (currentTickIndex > upperBound) {
            currentTickIndex = -~(currentTickIndex - 1);
        }
        lowerTick = currentTickIndex - spaceBetweenCurTicks / 2;
        upperTick = currentTickIndex + spaceBetweenCurTicks / 2;
        lowerTick = lowerTick - (lowerTick % tickSpacing);
        upperTick =
            upperTick % tickSpacing
                ? upperTick + tickSpacing - (upperTick % tickSpacing)
                : upperTick;
        if (poolName === "BLUEFIN-STSUI-SUI" ||
            poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI" ||
            poolName === "BLUEFIN-LYF-STSUI-SUI") {
            let suiPerLst = await (0, stsui_sdk_1.stSuiExchangeRate)((0, stsui_sdk_1.getConf)().LST_INFO, true);
            const feeConfig = await (0, stsui_sdk_1.getLstInfo)((0, stsui_sdk_1.getConf)().LST_INFO, true);
            const redeemFee = feeConfig?.content.fields.fee_config.fields.element.fields
                .redeem_fee_bps;
            suiPerLst = new decimal_js_1.Decimal(suiPerLst)
                .minus(new decimal_js_1.Decimal(suiPerLst).mul(new decimal_js_1.Decimal(redeemFee)).div(10000))
                .toString();
            const curSqrtRedeemPrice = cetus_sui_clmm_sdk_1.TickMath.priceToSqrtPriceX64(new decimal_js_1.Decimal(suiPerLst), 9, 9);
            const lowerTickFromRedeemPrice = Math.floor(cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToTickIndex(curSqrtRedeemPrice));
            if (Math.min(lowerTickFromRedeemPrice, currentTickIndex) <= curLowerTick) {
                console.log(`Math.min(lowerTickFromRedeemPrice, currentTickIndex) is lesser than current lower tick. lowerTick from redeem price: ${lowerTickFromRedeemPrice}, currentTickIndex: ${currentTickIndex}, current lower tick: ${curLowerTick}`);
                return;
            }
            lowerTick = Math.min(lowerTickFromRedeemPrice, currentTickIndex);
            upperTick = lowerTick + 2;
            // let coinBAmount = 1_000_000_000;
            // while (coinBAmount > 250_000_000) {
            //   upperTick++;
            //   const tempAmounts =
            //     ClmmPoolUtil.estLiquidityAndcoinAmountFromOneAmounts(
            //       lowerTick,
            //       upperTick,
            //       new BN(750_000_000),
            //       true,
            //       true,
            //       0.1,
            //       current_sqrt_price,
            //     );
            //   coinBAmount = tempAmounts.coinAmountB.toNumber();
            // }
        }
    }
    if (lowerTick === curLowerTick && upperTick === curUpperTick) {
        console.log("same ticks", lowerTick, upperTick);
        return;
    }
    console.log(lowerTick, upperTick, curLowerTick, curUpperTick);
    const curPrice = cetus_sui_clmm_sdk_1.TickMath.sqrtPriceX64ToPrice(current_sqrt_price, coinA.expo, coinB.expo);
    const totalA = (amount0 / 10 ** coinA.expo) * curPrice.toNumber();
    const totalB = amount1 / 10 ** coinB.expo;
    const sum = totalA + totalB;
    if ((totalA * 100) / sum > percentageLimit &&
        (totalB * 100) / sum > percentageLimit &&
        poolName != "BLUEFIN-STSUI-SUI" &&
        poolName != "BLUEFIN-FUNGIBLE-STSUI-SUI" &&
        poolName != "BLUEFIN-LYF-STSUI-SUI") {
        return;
    }
    txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, lowerTick.toString(), upperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
    return txb;
}
async function checkRatio(poolName, liquidity) {
    const pool = await (0, alphafi_sdk_1.getPool)(poolName, true);
    const cetus_pool = await (0, alphafi_sdk_1.getCetusPool)(poolName, true);
    const cetus_investor = (await (0, alphafi_sdk_1.getInvestor)(poolName, true));
    if (pool && cetus_pool && cetus_investor) {
        const coinAmounts = cetus_sui_clmm_sdk_1.ClmmPoolUtil.getCoinAmountFromLiquidity(new bn_js_1.default(liquidity), new bn_js_1.default(cetus_pool.content.fields.current_sqrt_price), cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(Number(cetus_investor.content.fields.lower_tick)), cetus_sui_clmm_sdk_1.TickMath.tickIndexToSqrtPriceX64(Number(cetus_investor.content.fields.upper_tick)), false);
        console.log(coinAmounts.coinA.toNumber(), coinAmounts.coinB.toNumber(), cetus_investor.content.fields.lower_tick, cetus_investor.content.fields.upper_tick);
    }
}
function toTwosComplementIfPossible(value) {
    return value >>> 0;
}
async function priceToTickIndexBoth(poolName, lPrice, uPrice, decimalA, decimalB) {
    const cetusSDK = new cetus_sui_clmm_sdk_1.CetusClmmSDK(index_js_2.cetusMainnetSDKOptions);
    let current_tick_index;
    let tickSpacing;
    if (alphafi_sdk_1.poolInfo[poolName].parentProtocolName === "CETUS") {
        const pool = await cetusSDK.Pool.getPool(alphafi_sdk_1.cetusPoolMap[poolName]);
        current_tick_index = pool.current_tick_index;
        tickSpacing = pool.tickSpacing;
    }
    else {
        const bluefinpool = (await (0, alphafi_sdk_1.getParentPool)(poolName, false));
        current_tick_index =
            bluefinpool?.content.fields.current_tick_index.fields.bits;
        tickSpacing =
            bluefinpool?.content.fields.ticks_manager.fields.tick_spacing.toString();
    }
    if (!current_tick_index || !tickSpacing) {
        throw new Error("current tick or tick spacing undefined");
    }
    let ilt = cetus_sui_clmm_sdk_1.TickMath.priceToInitializableTickIndex(new decimal_js_1.Decimal(lPrice), decimalA, decimalB, Number(tickSpacing));
    let ult = cetus_sui_clmm_sdk_1.TickMath.priceToInitializableTickIndex(new decimal_js_1.Decimal(uPrice), decimalA, decimalB, Number(tickSpacing));
    if (ilt === ult) {
        if (current_tick_index > ilt) {
            ult = cetus_sui_clmm_sdk_1.TickMath.getNextInitializableTickIndex(ult, Number(tickSpacing));
        }
        else if (current_tick_index < ilt) {
            ilt = cetus_sui_clmm_sdk_1.TickMath.getPrevInitializableTickIndex(ilt, Number(tickSpacing));
        }
        else {
            // todo: write exact logic for this case
            ult = cetus_sui_clmm_sdk_1.TickMath.getNextInitializableTickIndex(ult, Number(tickSpacing));
        }
    }
    return [ilt, ult];
}
async function getManualRebalanceTxb(poolName, rebalanceCap, lowerPrice, upperPrice, swap_using_bluefin, rebalance_using_base_pool) {
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    const pooltvl = await (0, index_js_1.fetchTVL)(poolName, true);
    console.log("hehhee", pooltvl);
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    const ticks = await priceToTickIndexBoth(poolName, Number(lowerPrice), Number(upperPrice), coinA.expo, coinB.expo);
    const lowerTick = ticks[0];
    const upperTick = ticks[1];
    const txb = await getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, lowerTick.toString(), upperTick.toString(), swap_using_bluefin, rebalance_using_base_pool);
    return txb;
}
async function getManualRebalanceUsingTicksTxb(poolName, rebalanceCap, lowerTick, upperTick, swap_using_bluefin, rebalance_using_base_pool) {
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    const pooltvl = await (0, index_js_1.fetchTVL)(poolName, true);
    console.log("hehhee", pooltvl);
    const loops = Math.max(15, Number(pooltvl) / 100000);
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    console.log(lowerTick, upperTick, loops);
    const txb = new transactions_1.Transaction();
    const poolData = alphafi_sdk_1.poolInfo[poolName];
    if (poolData.parentProtocolName === "BLUEFIN") {
        if (poolData.strategyType === "AUTOBALANCE-LIQUIDITY-POOL") {
            await (0, alphafi_sdk_1.collectRewardTxb)(poolName, true, txb);
        }
        else if (poolData.strategyType === "LEVERAGE-YIELD-FARMING") {
            const alphalendClient = new alphalend_sdk_1.AlphalendClient("mainnet", (0, alphafi_sdk_1.getSuiClient)());
            await alphalendClient.updatePrices(txb, [
                coinAName === "SUI" ? "0x2::sui::SUI" : coinA.type,
                coinBName === "SUI" ? "0x2::sui::SUI" : coinB.type,
            ]);
            await (0, alphafi_sdk_1.collectAndSwapRewardsLyf)(poolName, txb);
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_lyf_pool::rebalance_bluefin`,
                typeArguments: [coinA.type, coinB.type],
                arguments: [
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_LYF_VERSION),
                    txb.object(poolData.poolId),
                    txb.object((0, alphafi_sdk_1.getConf)().LENDING_PROTOCOL_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        if (poolName === "BLUEFIN-SUI-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUI_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-USDT-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["USDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["USDT-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["USDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_USDT_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUSD-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["AUSD-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-AUSD"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_AUSD_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-AUSD"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUI-BUCK") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-BUCK"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUI_BUCK_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUI-AUSD") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-AUSD"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["AUSD-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["AUSD"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUI_AUSD_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["AUSD-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WBTC-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["WBTC-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WBTC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WBTC_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-ALPHA-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["ALPHA-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-USDC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_ALPHA_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-NAVX-VSUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["NAVX"].type,
                    alphafi_sdk_1.coinsList["VSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["NAVX-VSUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-VSUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["NAVX"].type,
                    alphafi_sdk_1.coinsList["VSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_NAVX_VSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["NAVX-VSUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["VSUI-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-BLUE-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-BLUE-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-USDC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_2_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SEND-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SEND"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SEND-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SEND"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SEND"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SEND_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SEND"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WBTC-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["WBTC-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WBTC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WBTC"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WBTC_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WBTC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-DEEP-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.object(poolData.parentPoolId),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-ALPHA-STSUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_second_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_ALPHA_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ALPHA"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_second_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["ALPHA"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_ALPHA_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ALPHA-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ALPHA"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-USDT-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["USDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["USDT-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-USDT"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-SUI-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v4`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-SUIUSDT-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIUSDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUIUSDT-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIUSDT"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUIUSDT-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIUSDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUIUSDT-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIUSDT"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIUSDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUIUSDT_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIUSDT"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-DEEP-BLUE") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-BLUE"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-DEEP"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-DEEP-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-BLUE-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-WSOL") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["WSOL"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WSOL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WSOL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["WSOL"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_WSOL_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WSOL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WSOL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-ETH") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["ETH"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ETH-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ETH"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["ETH"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_ETH_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["ETH-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-ETH"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-BUCK") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_BUCK_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-BUCK"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BUCK"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_BUCK_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["BUCK-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-BUCK"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-MUSD") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["MUSD"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_MUSD_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["MUSD-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-MUSD"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["MUSD"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_MUSD_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["MUSD-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-MUSD"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-SUIBTC-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUIBTC-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIBTC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_SUIBTC_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        if (poolName === "BLUEFIN-FUNGIBLE-STSUI-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_ft_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_FUNGIBLE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["STSUI-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_ft_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    poolData.receiptType,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_FUNGIBLE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-SUI-LBTC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["LBTC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-LBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["LBTC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v4`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-LBTC-SUIBTC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-SUIBTC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["LBTC"].type,
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["LBTC-SUIBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-LBTC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["LBTC"].type,
                    alphafi_sdk_1.coinsList["SUIBTC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["DEEP"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_V2_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_LBTC_SUIBTC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_DEEP_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-LBTC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WAL-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::collect_and_swap_rewards_to_token_b_bluefin`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v3`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["WAL-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WAL"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WAL_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WAL"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-WAL-STSUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_second_investor::rebalance`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WAL_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WAL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WAL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_second_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_WAL_STSUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WAL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-WAL"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-WAL-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["WAL-USDC"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-WAL"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-SUIUSDT-USDC-ZERO-ZERO") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUIUSDT"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUIUSDT-USDC-ZERO-ZERO"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUIUSDT"]),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL_AUTOCOMPOUND),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-SUI-USDC-175") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC-175"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_first_pool::update_pool_v4`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-DEEP-SUI-175") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["DEEP"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["DEEP-SUI-175"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["DEEP-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-WAL-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["WAL"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["WAL-SUI"]),
                    txb.object(alphafi_sdk_1.cetusPoolMap["WAL-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_sui_second_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-AUTOBALANCE-XBTC-SUIBTC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_investor::rebalance_v2`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[coinAName].type,
                    alphafi_sdk_1.coinsList[coinBName].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(poolData.parentPoolId),
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-XBTC"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]), //not in use
                    txb.object(alphafi_sdk_1.cetusPoolMap["SUIBTC-SUI"]), //not in use
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO), //not in use
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE), //not in use
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_type_1_pool::update_pool_v3`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, alphafi_sdk_1.coinsList[coinBName].type],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_BLUEFIN_AUTOBALANCE_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    else {
        if (poolData.packageNumber === 2) {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_cetus_sui_investor::rebalance`,
                typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_2_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_cetus_sui_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1].type,
                    alphafi_sdk_1.coinsList[alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_2_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                    txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else {
            if (coinBName === "SUI") {
                txb.moveCall({
                    target: `${poolData.packageId}::alphafi_cetus_sui_investor::rebalance`,
                    typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
                    arguments: [
                        txb.object(poolData.investorId),
                        txb.object(rebalanceCap),
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                        txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                        txb.pure.u32(loops),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_sui_pool::update_pool`,
                    typeArguments: [coinA.type, coinB.type],
                    arguments: [
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else if (poolName === "WUSDC-WBTC" ||
                poolName === "USDC-USDT" ||
                poolName === "USDC-WUSDC" ||
                poolName === "USDC-ETH") {
                txb.moveCall({
                    target: `${poolData.packageId}::alphafi_cetus_investor_base_a::rebalance`,
                    typeArguments: [coinA.type, coinB.type],
                    arguments: [
                        txb.object(poolData.investorId),
                        txb.object(rebalanceCap),
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap[`${coinAName}-SUI`]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                        txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                        txb.pure.u32(loops),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool_base_a::update_pool`,
                    typeArguments: [coinA.type, coinB.type],
                    arguments: [
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap[`${coinAName}-SUI`]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
            else {
                txb.moveCall({
                    target: `${poolData.packageId}::alphafi_cetus_investor::rebalance`,
                    typeArguments: [coinA.type, coinB.type],
                    arguments: [
                        txb.object(poolData.investorId),
                        txb.object(rebalanceCap),
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                        txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                        txb.pure.u32(loops),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
                txb.moveCall({
                    target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_pool::update_pool`,
                    typeArguments: [coinA.type, coinB.type],
                    arguments: [
                        txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                        txb.object(poolData.poolId),
                        txb.object(poolData.investorId),
                        txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                        txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                        txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                        txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                        txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                        txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                    ],
                });
            }
        }
    }
    return txb;
}
async function getManualRebalanceUsingTicksLoopsTxb(poolName, rebalanceCap, lowerTick, upperTick, loops) {
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    const pooltvl = await (0, index_js_1.fetchTVL)(poolName, true);
    console.log("hehhee", pooltvl);
    //const loops = Math.max(1, Number(pooltvl) / 100_000);
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    const txb = new transactions_1.Transaction();
    if (coinBName === "SUI") {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_sui_investor::rebalance`,
            typeArguments: [alphafi_sdk_1.coinsList[coinAName].type, coinB.type],
            arguments: [
                txb.object(alphafi_sdk_1.poolInfo[poolName].investorId),
                txb.object(rebalanceCap),
                txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                txb.pure.u64(lowerTick),
                txb.pure.u64(upperTick),
                txb.pure.u64(loops),
                txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
            ],
        });
    }
    else {
        txb.moveCall({
            target: `${(0, alphafi_sdk_1.getConf)().ALPHA_LATEST_PACKAGE_ID}::alphafi_cetus_investor::rebalance`,
            typeArguments: [coinA.type, coinB.type],
            arguments: [
                txb.object(alphafi_sdk_1.poolInfo[poolName].investorId),
                txb.object(rebalanceCap),
                txb.object((0, alphafi_sdk_1.getConf)().VERSION),
                txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                txb.object((0, alphafi_sdk_1.getConf)().CETUS_REWARDER_GLOBAL_VAULT_ID),
                txb.object(alphafi_sdk_1.cetusPoolMap[`${coinBName}-SUI`]),
                txb.object(alphafi_sdk_1.cetusPoolMap["CETUS-SUI"]),
                txb.pure.u64(lowerTick),
                txb.pure.u64(upperTick),
                txb.pure.u64(loops),
                txb.object(alphafi_sdk_1.cetusPoolMap[poolName]),
                txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
            ],
        });
    }
    return txb;
}
// async function getCurrentTicks(
//   poolName: PoolName,
// ) {
//   const cetusInvestor = await getInvestor(poolName, {
//     suiClient: options.suiClient,
//   });
//   if (cetusInvestor) {
//     let curLowerTick = cetusInvestor.content.fields.lower_tick;
//     let curUpperTick = cetusInvestor.content.fields.upper_tick;
//     const upperBound = 443636;
//     if (curLowerTick > upperBound) {
//       curLowerTick = -~(curLowerTick - 1);
//     }
//     if (curUpperTick > upperBound) {
//       curUpperTick = -~(curUpperTick - 1);
//     }
//   }
// }
async function migrateToNewPool(poolName, rebalanceCap, lowerTick, upperTick, swap_using_bluefin, rebalance_using_base_pool) {
    // AlphaFi Mascot
    //
    //      a
    //    ~~|~~
    //     / \
    //
    /////////////////
    const pooltvl = await (0, index_js_1.fetchTVL)(poolName, true);
    console.log("hehhee", pooltvl);
    const loops = Math.max(15, Number(pooltvl) / 100000);
    const coinAName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin1;
    const coinA = alphafi_sdk_1.coinsList[coinAName];
    const coinBName = alphafi_sdk_1.doubleAssetPoolCoinMap[poolName].coin2;
    const coinB = alphafi_sdk_1.coinsList[coinBName];
    console.log(lowerTick, upperTick, loops);
    const txb = new transactions_1.Transaction();
    const poolData = alphafi_sdk_1.poolInfo[poolName];
    if (poolData.parentProtocolName === "BLUEFIN") {
        if (poolName === "BLUEFIN-STSUI-USDC") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_investor::migrate_to_new_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.pure.u32(loops),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_USDC_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin), // swap using bluefin (just for tokenb-sui swaps)
                    txb.pure.bool(rebalance_using_base_pool), //rebalance using base pool
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_first_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["USDC"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_STSUI_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object((0, alphafi_sdk_1.getConf)().CETUS_GLOBAL_CONFIG_ID),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_STSUI_USDC_ZERO_ONE_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object(alphafi_sdk_1.cetusPoolMap["USDC-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["SUI-USDC"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.pure.bool(swap_using_bluefin),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
        else if (poolName === "BLUEFIN-STSUI-SUI") {
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_investor::migrate_to_new_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object(poolData.investorId),
                    txb.object(rebalanceCap),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.pure.u32(toTwosComplementIfPossible(Number(lowerTick))),
                    txb.pure.u32(toTwosComplementIfPossible(Number(upperTick))),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["STSUI-SUI"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["STSUI-SUI-ZERO-ZERO"]),
                    txb.object(alphafi_sdk_1.bluefinPoolMap["BLUE-SUI"]),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
            txb.moveCall({
                target: `${poolData.packageId}::alphafi_bluefin_stsui_sui_pool::update_pool`,
                typeArguments: [
                    alphafi_sdk_1.coinsList["STSUI"].type,
                    alphafi_sdk_1.coinsList["SUI"].type,
                    alphafi_sdk_1.coinsList["BLUE"].type,
                ],
                arguments: [
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_4_VERSION),
                    txb.object(poolData.poolId),
                    txb.object(poolData.investorId),
                    txb.object((0, alphafi_sdk_1.getConf)().ALPHA_DISTRIBUTOR),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_GLOBAL_CONFIG),
                    txb.object(poolData.parentPoolId),
                    txb.object((0, alphafi_sdk_1.getConf)().BLUEFIN_BLUE_SUI_POOL),
                    txb.object((0, alphafi_sdk_1.getConf)().LST_INFO),
                    txb.object((0, alphafi_sdk_1.getConf)().SUI_SYSTEM_STATE),
                    txb.object((0, alphafi_sdk_1.getConf)().CLOCK_PACKAGE_ID),
                ],
            });
        }
    }
    return txb;
}
//# sourceMappingURL=rebalance.js.map